import React from "react";
import { Menu } from "antd";
import { PieChartOutlined, TeamOutlined } from "@ant-design/icons";
import { useMenu } from "../../../common/contexts/MenuContext";
import { useHistory } from "react-router";

const CustomerMenu = () => {
  const { selectedMenu, setSelectedMenu } = useMenu();
  const history = useHistory();
  return (
    <Menu theme="dark" selectedKeys={selectedMenu} mode="vertical">
      <Menu.Item
        key="1"
        icon={<PieChartOutlined />}
        onClick={() => {
          setSelectedMenu(["1"]);
          history.push("/customer/orders");
        }}
      >
        Orders
      </Menu.Item>
    </Menu>
  );
};

export default CustomerMenu;
